module.exports = __webpack_public_path__ + "img/isocel1.d692fd8f.jpg";